import React, { useMemo } from 'react';

import type { HTMLData } from './../../ricos-schema/next-schema';
import type { PluginProps } from './../../ricos-types';
import { useNodeAttrs } from './../../_shared/use-node-attrs';
import { htmlConverter } from './../html-converter';

import { HtmlViewer } from '../viewer/html-viewer';

export const Html: React.FC<PluginProps> = ({ settings, node }) => {
  const { patchPmNodeAttrs, pmNodeAttrs } = useNodeAttrs(node.attrs.id, 'HTML');

  const onIframeHeightChange = (height: number) => {
    patchPmNodeAttrs?.({
      ...pmNodeAttrs,
      containerData: { ...pmNodeAttrs.containerData, height: { custom: `${height}` } },
      iframeHeight: height,
    });
  };

  const ricosNode = useMemo(() => htmlConverter.fromPm.convert(node.toJSON()), [node]);

  return (
    <HtmlViewer
      htmlData={ricosNode?.htmlData as HTMLData}
      settings={settings}
      onIframeHeightChange={onIframeHeightChange}
    />
  );
};
